/**
 * Where the back office is mounted, and what it is going to contain.
 *
 * The whole map lives here from the first slice on purpose: the rail shows every
 * section the area is to have, with the unbuilt ones disabled, so a sysadmin can
 * see the shape of the back office and the next slices land somewhere already
 * sized for them.
 */
export const ADMIN_BASE = "/admin";

export const routes = {
  /** The dashboard. The landing surface, not a redirect to one. */
  resumen: ADMIN_BASE,
  monitorizacion: `${ADMIN_BASE}/monitorizacion`,
  tecnicos: `${ADMIN_BASE}/tecnicos`,
  /** La ficha de una persona. Por `user_id`, no por perfil: la sección lista
      personas y una persona puede tener varios. */
  tecnico: (userId: string) => `${ADMIN_BASE}/tecnicos/${userId}`,
  productoras: `${ADMIN_BASE}/productoras`,
  /** La ficha de una. Función y no literal: el id va dentro y el listado, el rail
      y el router derivan la ruta de aquí en vez de escribirla tres veces. */
  productora: (id: string) => `${ADMIN_BASE}/productoras/${id}`,
  configuracion: `${ADMIN_BASE}/configuracion`,
  productos: `${ADMIN_BASE}/productos`,
} as const;

export interface AdminSection {
  to: string;
  label: string;
  icon: "grid" | "clock" | "users" | "case" | "set" | "star";
  /** False until the slice that builds it lands. Rendered as a disabled label,
      never as a link: a dead link that navigates to a blank screen is worse than
      a grey word. */
  built: boolean;
  /** Shown as a hint on the disabled ones, so «not yet» is legible as a plan
      rather than as something broken. */
  hint?: string;
}

export const SECTIONS: AdminSection[] = [
  { to: routes.resumen, label: "Resumen", icon: "grid", built: true },
  { to: routes.monitorizacion, label: "Monitorización", icon: "clock", built: true },
  { to: routes.tecnicos, label: "Técnicos", icon: "users", built: true },
  { to: routes.productoras, label: "Productoras", icon: "case", built: true },
  { to: routes.configuracion, label: "Configuración", icon: "set", built: true },
  { to: routes.productos, label: "Productos", icon: "star", built: true },
];
